import React from 'react';
import { usePermissoes } from '../context/PermissoesContext';

// ════════════════════════════════════════════════════════════════════════════
// SePode.jsx — r87 (Rodada C)
// ────────────────────────────────────────────────────────────────────────────
// Renderiza children apenas se o usuário tem permissão.
//
// USO:
//   <SePode rotina="usuarios" acao="incluir">
//     <button onClick={abrirNovo}>Novo</button>
//   </SePode>
//
//   <SePode rotina="usuarios" acao="alterar" fallback={<span>—</span>}>
//     <BtnIcone icone="alterar" onClick={...} />
//   </SePode>
// ════════════════════════════════════════════════════════════════════════════

function SePode({ rotina, acao = 'visualizar', children, fallback = null }) {
  const { pode } = usePermissoes();
  if (!pode(rotina, acao)) return fallback;
  return children;
}

export default SePode;
